import CommunityFeed from "../components/CommunityFeed";
import { Box, ThemeProvider } from "@mui/material";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import type { RootState } from "../store";
import Theme from "../utils/theme";

const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

const Community: React.FC = () => {
    const themeState = useTypedSelector((state) => state.theme);
    const theme = useMemo(() => Theme(themeState.mode), [themeState.mode]);

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: "flex" }}>
                <CommunityFeed />
            </Box>
        </ThemeProvider>
    );
};

export default Community;
